import BaseModel from '@/shared/models/BaseModel'

export default class Benefit extends BaseModel {

    defaults() {
        return {
            id         : null,
            name       : null,
            description: null,
            tos_url    : null,
            icon_url   : null,
            color      : null,
            type       : 'advantage',
            level_id   : null,
            order      : null,
            created_at : null,
        }
    }

    static async list(level_id, additionalConfig = {}) {
        const response = await this.request({
            url: `/level/${level_id}/benefit`,
            method: 'get',
            ...additionalConfig,
        })

        if (!response || !response.data || response.status !== 200 )
            return

        return response.data.map(benefit => new this(benefit))
    }
}